export enum CallCenterCallStatusEnum {
  NewCall = 'NOVA',
  Transfer = 'TRANSFERENCIA',
  Finish = 'FINALIZACAO',
}
